import { render } from "./fiscal.vue?vue&type=template&id=4b719b24"
import script from "./fiscal.vue?vue&type=script&lang=js"
export * from "./fiscal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__